export default "__VITE_ASSET__Bk13khRb__"